<template>
	<div class="page-leads-dashboard">
		<div class="page-leads-dashboard__header">
			<div class="container">
				<div class="leads-dashboard-header" ref="propertiesHeader">
					<div class="leads-dashboard-header__container">
						<router-link class="breadcrumbs__link" :to="{ name: goInDashboard() ? 'CustomersAdmin' : 'CustomersAgent' }">
							<SvgIcon class="breadcrumbs__icon" iconName="ico-arrow-left"/>
						</router-link>
						<div class="leads-dashboard-header__breadcrumb">
							<div class="leads-dashboard-header__breadcrumb-wrap" ref="breadcrumbs">
								<span class="section-title section-title--breadcrumbs">My Leads Dashboard</span>
							</div>
							<span class="leads-dashboard-header__breadcrumb-count" v-if="customerView && leadDashboardCounters.customersCount > 0">{{ leadDashboardCounters.customersCount }} counts</span>
							<span class="leads-dashboard-header__breadcrumb-count" v-else-if="customerView && leadDashboardCounters.customersCount === 0">{{ leadDashboardCounters.customersCount }} count</span>
							<span class="leads-dashboard-header__breadcrumb-count" v-else-if="!customerView && leadDashboardCounters.propertiesCount > 0">{{ leadDashboardCounters.propertiesCount }} counts</span>
							<span class="leads-dashboard-header__breadcrumb-count" v-else-if="!customerView && leadDashboardCounters.propertiesCount === 0">{{ leadDashboardCounters.propertiesCount }} count</span>
						</div>
					</div>
					<div class="page-leads-dashboard__tabs-button">
						<a class="btn-tab left-tab-button" :class="{ active: customerView }" @click="chooseTab(1)">Customer View</a>
						<a class="btn-tab right-tab-button" :class="{ active: !customerView }" @click="chooseTab(2)">Property View</a>
					</div>
				</div>
			</div>
		</div>
		<div class="container">
			<div class="properties-listing__tabs-content">
				<transition name="fade" appear>
					<div class="properties-listing__tabs-inner" v-show="customerView">
						<div class="table__container">
							<template v-for="(table, index) in customersTables"> 
								<!-- {{ table }} -->
								<div class="table__item" :key="index">
										<BlockAccordion
											:data="table"
											:index="index"
											@setAgainTable="setAgainTable"
											@setAgainTableLead="setAgainTableLead"
											:infinitScrollFlag="infinitScrollFlag"
											@onSort="onSort"
											v-if="leadDashboardCounters.customersCount"
										/>
								</div>
							</template>
							<PartLoaderBig class="loader-table-bottom" v-if="preloaderTable"/>
						</div>
					</div>
				</transition>
				<transition name="fade" appear>
					<div class="properties-listing__tabs-inner" v-show="!customerView">
						<div class="table__container">
							<template v-for="(table, index) in propertiesTables">
								<div class="table__item table__item--with-img" :key="index">
									<BlockAccordion
										:data="table"
										:index="index"
										@setAgainTable="setAgainTable"
										@setAgainTableLead="setAgainTableLead"
										:infinitScrollFlag="infinitScrollFlag"
										@onSort="onSort"
									/>
								</div>
							</template>
							<PartLoaderBig class="loader-table-bottom" v-if="preloaderPropertyTable"/>
						</div>
					</div>
				</transition>
			</div>
		</div>
			<PartLoaderBig v-if="preloader || infinitScrollFlag"/>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import BlockAccordion from '@/components/blocks/BlockAccordion';
import PartLoaderBig from '@/components/parts/PartLoaderBig';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			customerView: true,
			preloader: false,
			active: true,
			customersTables: {},
			propertiesTables: {},
			propertiesLoaded: false,
			preloaderTable: true,
			preloaderPropertyTable: true,
			infinitScrollFlag: false
		};
	},
	components: {
		SvgIcon,
		BlockAccordion,
		PartLoaderBig
	},
	beforeMount() {
		this.preloader = true;
		this.preloaderTable = true;
		this.preloaderPropertyTable = true;
	},
	created() {
		if (this.$router.currentRoute.params && this.$router.currentRoute.params.flag && this.$router.currentRoute.params.flag === 'Customer Dashboard') {
			localStorage.setItem('tab', 'customer');
		} else if (this.$router.currentRoute.params && this.$router.currentRoute.params.flag && this.$router.currentRoute.params.flag === 'Property Dashboard') {
			localStorage.setItem('tab', 'property');
		}
		if (localStorage.getItem('tab')) {
			const tab = localStorage.getItem('tab') === 'customer' ? 1 : 2;
			this.customerView = localStorage.getItem('tab') === 'customer';
			this.chooseTab(tab);
		} 
	},
	async mounted() {
		// this.customerView = this.$route.params.flag !== 'Property Dashboard';
		if (this.$router.currentRoute.params && this.$router.currentRoute.params.flag && this.$router.currentRoute.params.flag === 'Customer Dashboard') {
			this.customerView = true;
		}
		this.preloader = true;
		this.preloaderTable = true;
		this.preloaderPropertyTable = true;
		if (this.customerView) {
			const customerPaginationObject = {
				order_by: 'last_name',
				order: 'asc',
				page: 1
			};
			await this.$store.dispatch('fetchStages');
			await this.$store.dispatch('leadDashboardCustomer', customerPaginationObject).then(() => { 
				this.preloaderTable = false; 
			}).catch(err => { console.log(err); });
		} 
		// await this.$store.dispatch('leadDashboardCustomerStages');
		// else {
		// 	this.$store.dispatch('leadDashboardProperties', obj).then(response => {
		// 		obj.only_lead = false;
		// 		this.$store.dispatch('leadDashboardProperties', obj).then(response => {
		// 			this.preloaderTable = false;
		// 			this.preloaderPropertyTable = false;
		// 		});
		// 		this.propertiesLoaded = true;
		// 	});
		// }
		this.preloader = false;
	},
	computed: {
		customersView() {
			const data = this.$store.getters.getLeadDashboardCustomers;
			Object.keys(data).forEach((match) => {
				data[match].forEach((item, index) => {
					item.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							data[match][index].property_type_label[i] = label;
						}
					});
				});
			});
			return data;
		},
		propertiesView() {
			const data = this.$store.getters.getLeadDashboardProperties;
			Object.keys(data).forEach((match) => {
				data[match].forEach((item, index) => {
					item.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							data[match][index].property_type_label[i] = label;
						}
					});
				});
			});
			return data;
		},
		leadDashboardCounters() {
			return this.$store.getters.getLeadDashboardCounters;
		},
		leadsCount() {
			return this.$store.getters.getLeadsCount;
		},
		allStages() {
			return this.$store.getters.getStages;
		},
		countLeadProperty() {
			return this.$store.getters.getCountLeadPropertyProperty;
		}
	},
	watch: {
		customersView() {
			this.fillTables(this.customersView, 'customers');
		},
		propertiesView() {
			this.fillTables(this.propertiesView, 'properties');
		}
	},
	methods: {
		fillTables(data, flag) {
			const stages = data;

			for (const key in stages) {
				const stageName = `${key.replace('st_', '').replaceAll('_', ' ')}`;
				const leadStage = this.allStages.find(item => item.id === 1);

				if (flag === 'customers') {
					this.createCustomersTable(key, stages[key], stageName, this.countLeadProperty, leadStage.color, leadStage.id);
				} else {
					this.createPropertiesTable(key, stages[key], stageName, this.countLeadProperty, leadStage.color, leadStage.id);
				}
			}
			this.leadsCount.forEach((item) => {
				this.allStages.forEach((stage) => {
					if (stage.id === item.stage_id && stage.title !== 'Lead') {
						if (flag === 'customers') {
							this.createCustomersTable(stage.title, [], `${stage.title.replace('st_', '').replaceAll('_', ' ')}`, item.count, stage.color, stage.id);
						} else {
							this.createPropertiesTable(stage.title, [], `${stage.title.replace('st_', '').replaceAll('_', ' ')}`, item.count, stage.color, stage.id);
						}
					}
				});
			});
		},
		async setAgainTable(obj) {
			if (this.customerView) {
				this.infinitScrollFlag = true;
				const stage = this.allStages.find(item => item.id === obj.stageId);

				const objForStagePaginationRequest = {
					order_by: obj.sortBy,
					order: obj.order,
					stage: obj.stageId,
					page: obj.page,
					stageName: stage.title
				};
				await this.$store.dispatch('leadDashboardCustomerStages', objForStagePaginationRequest);
				this.init();
				this.infinitScrollFlag = false;
			} else {
				this.infinitScrollFlag = true;
				const stage = this.allStages.find(item => item.id === obj.stageId);

				const objForStagePaginationRequest = {
					order_by: obj.sortBy,
					order: obj.order,
					stage: obj.stageId,
					page: obj.page,
					stageName: stage.title
				};
				await this.$store.dispatch('leadDashboardPropertyStages', objForStagePaginationRequest);
				this.init();
				this.infinitScrollFlag = false;
			}
		},
		async setAgainTableLead(obj) {
			this.infinitScrollFlag = true;
			const stage = this.allStages.find(item => item.id === obj.stageId);

			const objForStagePaginationRequest = {
				order_by: obj.sortBy,
				order: obj.order,
				stage: obj.stageId,
				page: obj.page,
				stageName: stage.title
			};
			if (this.customerView) {
				await this.$store.dispatch('leadDashboardCustomer', objForStagePaginationRequest);
			} else {
				await this.$store.dispatch('leadDashboardProperties', objForStagePaginationRequest);
			}
			this.infinitScrollFlag = false;
		},
		init() {
			if (this.customerView) {
				const stages = this.customersView;
				for (const key in stages) {
					const stageName = `${key.replace('st_', '').replaceAll('_', ' ')}`;
					const leadStage = this.allStages.find(item => item.title === stageName);
					const stageCount = this.leadsCount.find(item => item.stage_id === leadStage.id);
					if (stageCount) {
						this.createCustomersTable(key, stages[key], stageName, stageCount.count, leadStage.color, leadStage.id);
					} else {
						this.createCustomersTable(key, stages[key], stageName, this.countLeadProperty, leadStage.color, leadStage.id);
					}
				}
			} else {
				const stages = this.propertiesView;
				for (const key in stages) {
					const stageName = `${key.replace('st_', '').replaceAll('_', ' ')}`;
					const leadStage = this.allStages.find(item => item.title === stageName);
					const stageCount = this.leadsCount.find(item => item.stage_id === leadStage.id);
					if (stageCount) {
						this.createPropertiesTable(key, stages[key], stageName, stageCount.count, leadStage.color, leadStage.id);
					} else {
						this.createPropertiesTable(key, stages[key], stageName, this.countLeadProperty, leadStage.color, leadStage.id);
					}
				}
			}
		},
		createCustomersTable(flag, stage, stageName, count, color, stageId) {
			this.customersTables[flag] = {
				buttonName: stageName,
				buttonNameColor: color,
				stageId: stageId,
				userNum: count > 1 ? count + ' Customers' : count + ' Customer',
				sort: 'last_name',
				DataAccordionTable: {
					stageTable: true,
					stickyHeader: true,
					noCollapse: false,
					noLocalSorting: false,
					tableClass: 'text-nowrap',
					fields: [
						{ key: 'last_name', label: 'Name', flag: 'match', sortable: true, stickyColumn: true, variant: 'property thead-lg' },
						{ key: 'stage_info', label: 'Stage', sortable: false, stickyColumn: true, variant: 'stage' },
						{ key: 'offering_type_label', label: 'Offering Type', sortable: true, stickyColumn: true, variant: 'service-type' },
						{ key: 'area_label', label: 'Area', sortable: true, stickyColumn: true, variant: 'area' },
						{ key: 'property_type_label', label: 'Property Type', sortable: true, stickyColumn: true, variant: 'property-type' },
						{ key: 'building_size_min', label: 'Bldg Size Min', sortable: true, stickyColumn: true, variant: 'building-size' },
						{ key: 'building_size_max', label: 'Bldg Size Max', sortable: true, stickyColumn: true, variant: 'building-size' },
						{ key: 'lot_size_min', label: 'Lot Size Min', sortable: true, stickyColumn: true, variant: 'lot-size' },
						{ key: 'lot_size_max', label: 'Lot Size Max', sortable: true, stickyColumn: true, variant: 'lot-size' },
						{ key: 'price_min', label: 'Price Min', sortable: true, stickyColumn: true, variant: 'price' },
						{ key: 'price_max', label: 'Price Max', sortable: true, stickyColumn: true, variant: 'price' },
						{ key: 'price_psf_min', label: 'Price per SF Min', sortable: true, stickyColumn: true, variant: 'price-psf' },
						{ key: 'price_psf_max', label: 'Price per SF Max', sortable: true, stickyColumn: true, variant: 'price-psf' },
						{ key: 'lease_price_min', label: 'Lease Price Min', sortable: true, stickyColumn: true, variant: 'lease-price' },
						{ key: 'lease_price_max', label: 'Lease Price Max', sortable: true, stickyColumn: true, variant: 'lease-price' },
						{ key: 'price_buildable_sf_min', label: 'Price per Buildable SF Min', sortable: true, stickyColumn: true, variant: 'price-buildable-sf' },
						{ key: 'price_buildable_sf_max', label: 'Price per Buildable SF Max', sortable: true, stickyColumn: true, variant: 'price-buildable-sf' },
						{ key: 'yearly_price_min', label: 'Yearly Price per SF Min', sortable: true, stickyColumn: true, variant: 'yearly-price' },
						{ key: 'yearly_price_max', label: 'Yearly Price per SF Max', sortable: true, stickyColumn: true, variant: 'yearly-price' },
						{ key: 'primary_phone', label: 'Phone', sortable: true, stickyColumn: true, variant: 'phone' },
						{ key: 'created_at', label: 'Date Listed', sortable: true, stickyColumn: true, variant: 'date' },
						{ key: 'iconArrow', label: '', flag: 'leadCustomers', sortable: false, stickyColumn: true, variant: 'fixed-icon first-icon-fixed table-fixed-icon--dark-blue last-icon-fixed' }
					],
					items: stage
				}
			};
		},
		createPropertiesTable(flag, stage, stageName, count, color, stageId) {
			this.propertiesTables[flag] = {
				buttonName: stageName,
				buttonNameColor: color,
				stageId: stageId,
				userNum: count > 1 ? count + ' Properties' : count + ' Property',
				sort: 'title',
				DataAccordionTable: {
					stageTable: true,
					stickyHeader: true,
					noCollapse: false,
					noLocalSorting: false,
					tableClass: 'text-nowrap',
					fields: [
						{ key: 'title', label: 'Property', flag: 'match', sortable: true, stickyColumn: true, variant: 'property thead-lg' },
						{ key: 'stage_info', label: 'Stage', sortable: false, stickyColumn: true, variant: 'stage' },
						{ key: 'offering_type_label', label: 'Offering Type', sortable: true, stickyColumn: true, variant: 'listing-status' },
						{ key: 'area_label', label: 'Area', sortable: true, stickyColumn: true, variant: 'area' },
						{ key: 'property_type_label', label: 'Property Type', sortable: true, stickyColumn: true, variant: 'property-type' },
						{ key: 'building_size', label: 'Building Size', sortable: true, stickyColumn: true, variant: 'building-size' },
						{ key: 'lot_size', label: 'Lot Size', sortable: true, stickyColumn: true, variant: 'lot-size' },
						{ key: 'regular_price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
						{ key: 'price_buildable_sf', label: 'Price per Buildable SF', sortable: true, stickyColumn: true, variant: 'price-buildable-sf' },
						{ key: 'price_psf', label: 'Price per SF', sortable: true, stickyColumn: true, variant: 'price-psf' },
						{ key: 'lease_price', label: 'Lease Price', sortable: true, stickyColumn: true, variant: 'lease-price' },
						{ key: 'yearly_price', label: 'Yearly Price per SF', sortable: true, stickyColumn: true, variant: 'yearly-price' },
						{ key: 'listing_status_label', label: 'Listing Status', sortable: true, stickyColumn: true, variant: 'listing-status' },
						{ key: 'property_shark_link', label: 'Property Shark Link', sortable: false, stickyColumn: true, variant: 'property-shark-link' },
						{ key: 'updated_at', label: 'Date Updated', sortable: true, stickyColumn: true, variant: 'date-updated' },
						{ key: 'date_listed', label: 'Date Listed', sortable: true, stickyColumn: false, variant: 'date-icon' },
						{ key: 'iconArrow', label: '', flag: 'leadProperties', sortable: false, stickyColumn: true, variant: 'fixed-icon first-icon-fixed table-fixed-icon--dark-blue last-icon-fixed' }
					],
					items: stage
				}
			};
		},
		onSort(obj) {
			if (obj.stageId === 1) { 
				this.setAgainTableLead(obj);
			} else this.setAgainTable(obj);
		},
		async chooseTab(num) {
			this.customerView = num === 1;
			if (!this.customerView) {
				if (!this.propertiesLoaded) {
					this.preloaderPropertyTable = true;
					this.preloader = true; 
					const propertyPaginationObject = {
						order_by: 'title',
						order: 'asc',
						page: 1
					};
					await this.$store.dispatch('fetchStages');
					this.$store.dispatch('leadDashboardProperties', propertyPaginationObject).then(() => {
						this.propertiesLoaded = true;
						this.preloaderTable = false; 
						this.preloaderPropertyTable = false;
					}).catch(err => {
						console.log(err);
						this.propertiesLoaded = true;
						this.preloaderTable = false; 
						this.preloaderPropertyTable = false;
					});
					this.preloader = false;
				} 
				localStorage.setItem('tab', 'property');				
			} else {
				if (this.propertiesLoaded) {
					const customerPaginationObject = {
						order_by: 'last_name',
						order: 'asc',
						page: 1
					};
					await this.$store.dispatch('leadDashboardCustomer', customerPaginationObject).catch(err => { console.log(err); });
				} 
				localStorage.setItem('tab', 'customer');
			}
		},
		goInDashboard() {
			return this.$route.fullPath.includes('admin');
		}
	}
};
</script>
<style lang="scss" scoped>
.page-leads-dashboard .loader-big {
	position: fixed;
}
.leads-dashboard-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
	width: 100%;

	@include mq(850px) {
		flex-direction: column;
	}
}

.page-leads-dashboard__header {
	border-bottom: 1px solid $grey-light;
	margin-bottom: 42px;

	@include mq(1440px) {
		padding: 20px 0;
	}

	@include mq($lg) {
		padding: 0 0 20px;
		margin-bottom: 20px;
	}
}

.leads-dashboard-header__container {
	display: flex;
	align-items: flex-start;
	padding: 24px 0 12px;
	margin: 0;
	width: 100%;

	@include mq(1440px) {
		padding: 0;
	}

	@include mq(850px) {
		margin-bottom: 20px;
	}

	@include mq($md) {
		padding-left: 30px;
	}
}

/*--------------------------------------------------------------
## Breadcrumb
--------------------------------------------------------------*/
.breadcrumbs__link {
	color: $fiord;
	transition: $dur $ease;

	@include hover {
		.breadcrumbs__icon {
			color: $dodger-blue;
		}
	}
}

.breadcrumbs__icon {
	display: flex;
	margin-right: 3px;
	font-size: 26px;
	height: 26px;
	color: $fiord;

	@include mq($lg) {
		font-size: 25px;
		margin-right: 0;
	}

	@include mq($md) {
		position: absolute;
		height: 25px;
		top: -3px;
		left: 0;
	}
}

.leads-dashboard-header__breadcrumb {
	display: flex;
	flex-direction: column;
	padding-left: 4px;
	position: relative;

	@include mq(1440px) {
		padding: 0;
	}

	@include mq($xl) {
		max-width: 50%;
		flex: 0 0 50%;
	}

	@include mq($sm) {
		align-items: flex-start;
		max-width: 100%;
		flex: 0 0 100%;
		width: 100%;
	}
}

.leads-dashboard-header__breadcrumb-wrap {
	display: flex;
	align-items: center;
}

.section-title--breadcrumbs {
	display: block;
	letter-spacing: 0.25px;

	@include mq($md) {
		font-size: 18px;
	}
}

.leads-dashboard-header__breadcrumb-count {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $fiord;
	padding: 5px 0;
}

/*--------------------------------------------------------------
## Button
--------------------------------------------------------------*/
.page-leads-dashboard__tabs-button {
	display: flex;
	.left-tab-button {
		border-radius: 8px 0 0 8px;
	}

	.right-tab-button {
		border-radius: 0 8px 8px 0;
	}
}

.btn-tab  {
	text-decoration: none;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	color: $dodger-blue;
	padding: 10px 5px;
	outline: none;
	width: 100%;
	// transition: $dur $ease;
	cursor: pointer;
	background-color: $white;
	border-radius: 8px;
	border: 1px solid $dodger-blue;
	position: relative;
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 1.3;
	min-width: 207px;

	&:focus {
		outline: none;
		box-shadow: none;
	}

	&:disabled {
		@include hover {
			background-color: $dodger-blue;
			color: $white;
		}
	}

	@include hover {
		background-color: $dodger-blue-light;
	}

	&.active {
		pointer-events: none;
		background-color: $dodger-blue;
		color: $white;
	}

	@include mq($md) {
		min-width: 150px;
	}

	@include mq($sm) {
		min-width: 120px;
	}
}

// .fade-enter-active, .fade-leave-active {
// 	transition: opacity .4s;
// }

.fade-enter, .fade-leave-to {
	opacity: 0;
}

.page-leads-dashboard__tabs-content {
	position: relative;
}

.page-leads-dashboard__tabs-inner {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
}
.properties-listing__tabs-content {
	position: relative;

}
.loader-table-bottom {
	position: relative !important;
	height: 30vh !important;
}
</style>
